/* NPM */
import { useState } from "react";
import FormErrorMessage from "../../FormErrorMessage";
import { ChoiceButton } from "@ww-digital/web-foundations-react/modules";
/* UTILS */
import t from "../../../utils/translate";
import {
  FIRST_NAME,
  LAST_NAME,
  MEDICAL,
  EMAIL,
  LOCAL_STORAGE_EMAIL,
  PASSWORD,
  OPTIN
} from "../constants";
import fieldData from "./fieldData";
import useAppContext from "../../AppContext";
/* COMPONENTS */
import Textfield from "../Textfield";
import HidePasswordIcon from "./SVG/PasswordIconHide";
import ShowPasswordIcon from "./SVG/PasswordIconShow";
/* STYLES */
import styles from "./styles.module.scss";

const BuildInput = ({
  id,
  name,
  placeholder,
  rules,
  value,
  onChange,
  withAutofocus = false,
  ...rest
}) => (
  <Textfield
    id={id}
    name={name}
    placeholder={placeholder}
    value={value}
    onChange={onChange}
    rules={rules}
    styles={styles}
    withAutofocus={withAutofocus}
    className={styles.textField}
    wrapperClassName={styles.mainWrapper}
    inputWrapperClassName={styles.inputWrapper}
    {...rest}
  />
);

const AccountCreate = ({ onChange, createAccountError }) => {
  const { profile } = useAppContext();

  const [showPassword, setShowPassword] = useState(false);

  const renderErrorMessage = () => {
    if (!createAccountError) return null;

    let messageText = "";
    switch (createAccountError?.status) {
      case 422:
        messageText = t("JS_CREATE_ACCOUNT_UNPROCESSABLE");
        break;
      case 409:
        messageText = t("JS_CREATE_ACCOUNT_ALREADY_EXISTS");
        break;
      default:
        messageText = t("JS_CREATE_ACCOUNT_ERROR");
        break;
    }

    return <FormErrorMessage>{messageText}</FormErrorMessage>;
  };

  const handleCheckboxChange = e => {
    onChange(OPTIN, e?.target?.checked);
  };

  return (
    <div className={styles.accountCreation}>
      <div className={styles.names}>
        <BuildInput
          {...fieldData[FIRST_NAME]}
          value={profile[FIRST_NAME]}
          onChange={onChange}
        />
        <BuildInput
          {...fieldData[LAST_NAME]}
          value={profile[LAST_NAME]}
          onChange={onChange}
        />
      </div>

      <BuildInput
        {...fieldData[EMAIL]}
        value={profile[MEDICAL][EMAIL]}
        onChange={(key, value) => {
          window.localStorage.setItem(LOCAL_STORAGE_EMAIL, value);
          onChange(key, value, MEDICAL);
        }}
      />
      <BuildInput
        {...fieldData[PASSWORD]}
        type={showPassword ? "text" : "password"}
        value={profile[PASSWORD]}
        onChange={onChange}
        Icon={() => (
          <div
            className={styles.icon}
            onClick={() => setShowPassword(!showPassword)}
          >
            {showPassword ? <ShowPasswordIcon /> : <HidePasswordIcon />}
          </div>
        )}
      />
      <ChoiceButton
        type="checkbox"
        name="emailConsent"
        value={profile[OPTIN]}
        description={t("CLINICAL_EMAIL_CONSENT_TEXT")}
        checked={profile[OPTIN]}
        onChange={handleCheckboxChange}
        className={styles.checkbox}
      />
      {renderErrorMessage()}
    </div>
  );
};

export default AccountCreate;
